module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_chapel-4a09eeb46180fe6382bcc88cedc8432f.webp";